export const comments_5053770 = {"data":{"data":[],"links":{}}}